import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import MenuItem from '@material-ui/core/MenuItem'
import Select from '@material-ui/core/Select'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'

import _ from 'lodash'
import React, { Component } from 'react'
import { GET_LIST } from 'react-admin'

import { dataProvider } from '../../../providers'
import AutocompleteInput from '../autocompleteInput'
import { ValueSelectorStyled, FetchingStyled } from './style'

const styles = (theme) => ({
  fullWidth: {
    width: '100%',
  },
})

const MODE_AUTOCOMPLETE = 'autocomplete'
const MODE_SELECT = 'select'

class MetadataInput extends Component {
  constructor(props) {
    super(props)
    this.state = {
      reference: [],
      isFetching: false,
    }
  }

  static defaultProps = {
    mode: MODE_SELECT,
    sort: {
      field: 'name',
      order: 'ASC',
    },
    filters: {},
  }

  componentDidMount() {
    this.updateSelector()
  }

  componentDidUpdate(prevProps) {
    if (prevProps.reference !== this.props.reference || !_.isEqual(prevProps.filter, this.props.filter)) {
      this.updateSelector()
    }
  }

  updateSelector() {
    const { reference, filter } = this.props
    this.getReference(reference, filter, (list) => {
      this.setState({
        reference: list,
      })
    })
  }

  getReference(reference, filters, func) {
    const { sort } = this.props
    this.setState({
      isFetching: true,
    })
    dataProvider(GET_LIST, reference, {
      sort: sort,
      filter: filters,
      pagination: {},
    })
      .then((response) => {
        func(response.data)
      })
      .finally(() => {
        this.setState({
          isFetching: false,
        })
      })
  }

  handleChange(id) {
    if (!id || id === '') return null
    const { type, multi } = this.props
    const { value, onChange } = this.props.input ? this.props.input : this.props
    let newValue = [...value]

    if (!multi) {
      _.remove(newValue, (item) => {
        return item.type === type
      })
    }
    const newMetadataItem = {
      type: type,
      value: id,
    }
    newValue.push(newMetadataItem)
    onChange(newValue)
  }

  handleFilter = _.debounce((value) => {
    if (value) {
      const { reference, filter } = this.props
      this.getReference(reference, { ...filter, q: value }, (list) => {
        this.setState({
          reference: list,
        })
      })
    }
  }, 800)

  render() {
    const { optionText, optionValue, type, mode, placeholder, label, fullWidth, classes } = this.props
    const { value } = this.props.input ? this.props.input : this.props
    const { isFetching } = this.state

    const metadata = _.findLast(value, (item) => {
      return item.type === type
    })
    if (mode === MODE_AUTOCOMPLETE) {
      return (
        <FormControl className={classes.fullWidth} style={{ width: '100%' }}>
          <AutocompleteInput
            isFetching={isFetching}
            value={metadata ? metadata.value : null}
            meta={this.props.meta}
            choices={this.state.reference}
            onChange={(value) => this.handleChange(value)}
            optionText={optionText}
            optionValue={optionValue}
            setFilter={(value) => this.handleFilter(value)}
            translateChoice={false}
            placeholder={placeholder}
            label={label}
            fullWidth={fullWidth}
          />
        </FormControl>
      )
    }
    return (
      <FormControl className={classes.fullWidth} style={{ width: '100%' }} disabled={this.state.isFetching}>
        <InputLabel>{label}</InputLabel>
        <Select
          value={metadata ? metadata.value.toString() : 'metadataPlaceholder'}
          onChange={(event) => this.handleChange(event.target.value)}
          fullWidth
          placeholder={placeholder}
          renderValue={(value) => {
            const selectedReference = _.find(this.state.reference, (item) => {
              return item.id == value
            })
            const selectedName = selectedReference ? (optionText ? _.get(selectedReference, optionText) : selectedReference.name) : null
            return (
              <ValueSelectorStyled>
                {this.state.isFetching && (
                  <FetchingStyled>
                    <CircularProgress size={15} thickness={4} />
                  </FetchingStyled>
                )}
                {selectedName}
              </ValueSelectorStyled>
            )
          }}
        >
          <MenuItem value={'metadataPlaceholder'} disabled>
            {this.state.isFetching && (
              <FetchingStyled>
                <CircularProgress size={15} thickness={4} />
              </FetchingStyled>
            )}
          </MenuItem>
          {_.map(this.state.reference, (item) => (
            <MenuItem key={item.id} value={item.id.toString()}>
              {optionText ? _.get(item, optionText) : item.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    )
  }
}

export default withStyles(styles)(MetadataInput)
